var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"layout-single"},[(_vm.headline)?_c('text-headline-primary',{staticClass:"headline-primary"},[_vm._v("\n        "+_vm._s(_vm.headline)+"\n    ")]):_vm._e(),_vm._t("default"),_c('div')],2)}
var staticRenderFns = []

export { render, staticRenderFns }